<template>
  <div class="diligence">
    <van-tabs v-model="active">
      <van-tab title="我的绩效">
        <Target :createdate='createdate'></Target>
      </van-tab>
      <van-tab title="团队绩效" v-if="leader !== 0">
        <Result></Result>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import Target from "./target";
import Result from "./result";
import api from "@/apis";
import { getToken } from "@/utils/cookie";
export default {
  name: "diligence",
  components: {
    Target,
    Result,
  },
  data() {
    return {
      active: 0,
      leader: 0,
      createdate:''
    };
  },
  created() {
    this.getList();
  },
  methods: {
    //获取绩效
    getList() {
      api.selectEmployeeWithLeader({ empNo: getToken() }).then((data) => {
        this.leader = data.data.leader;
        this.createdate = data.data.createdate
      });
    },
  },
};
</script>

<style lang="scss" scoped>
$zoom: 1020 / 375;
@media screen and (max-width: 600px) {
  .diligence {
    width: 100%;
  }
}
@media screen and (min-width: 600px) {
  .diligence {
    width: 276px * $zoom;
  }
}
.diligence {
  font-size: 16px * $zoom;
  min-height: 100vh;
  background: #f4f5f8;
  position: relative;
  ::v-deep .van-tabs__wrap {
    height: 40px * $zoom !important;
    position: sticky;
    top: 0;
    z-index: 111;
  }
  ::v-deep .van-tab {
    font-size: 15px * $zoom;
    line-height: 30px * $zoom !important;
  }
  ::v-deep .van-tabs__line {
    width: 60px * $zoom;
    border-bottom: 2px solid green;
    background: none;
  }
  ::v-deep .van-tabs__content {
    padding: 10px * $zoom;
  }
}
</style>
